import angular from 'angular';
import { typeaheadSelectHubComponent } from './typeaheadSelectHubComponent';

angular
	.module('sh.typeaheadSelectHub', ['sh.identity'])
	.component('shTypeaheadSelectHub', typeaheadSelectHubComponent());
